<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div id="menu-page" class="menu menu-box-modal rounded-m" 
      data-menu-height="230" 
      data-menu-width="310">
    <h1 class="text-center font-700 mt-3 pt-2">Dr Theiss</h1>
    <p class="boxed-text-xl mt-1">
      Ak sa chcete dozvedieť o našej spoločnosti viac, dozviete sa viac na naších stránkach.
    </p>
    <a href="https://www.theiss.sk/" target="_blank" class="external-link btn btn-center-m btn-sm shadow-l rounded-s text-uppercase font-900 bg-green-light">Otvoriť stránku</a>
    <p class="color-theme text-center font-10 opacity-30 mt-2 mb-0 pb-0">Budete presmerovaný do externého prehliadača.</p>
  </div>  
</template>

<script>
export default {
  name: 'DrTheissPageModal',
  setup() {
    
  },
}
</script>
